/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import MaskedInput from 'react-text-mask';

const TextMaskCustomCpf = React.forwardRef((props, ref) => {
  const { inputRef, ...other } = props;

  // Pass the ref to the MaskedInput instance
  const setRef = (maskedInputEl) => {
    // Call MaskedInput's ref function if it exists
    if (typeof inputRef === 'function') {
      inputRef(maskedInputEl ? maskedInputEl.inputElement : null);
    }

    // Also update the ref (this is necessary when using React.forwardRef)
    if (ref) {
      ref(maskedInputEl ? maskedInputEl.inputElement : null);
    }
  };

  return (
    <MaskedInput
      {...other}
      ref={setRef}
      mask={[
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
      ]}
      placeholderChar={'\u2000'}
      showMask={!!other.value}
    />
  );
});

export default TextMaskCustomCpf;
